export default "asset/iconfont/393f06b3cb748bff98e35d4feae5987b.ttf";